import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Protege /admin. La autorización real y obligatoria vive en el backend
 * (requireAdmin en las rutas /products, /mercadopago, /admin/abandoned-carts,
 * etc.) — eso es lo que impide que alguien sin rol admin pueda leer o
 * modificar datos, sin importar lo que pase en el navegador.
 *
 * Este guard además evita que la UI de /admin llegue a renderizarse para un
 * usuario no-admin. A propósito NO usa `authService.getCurrentUser()` (que
 * lee de localStorage, editable desde devtools) para decidir el acceso:
 * hace una llamada fresca a GET /auth/me, que el backend recalcula contra
 * la tabla roles en cada request. Así, ni siquiera engañando el localStorage
 * del navegador se puede hacer aparecer la pantalla de admin.
 */
export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.parseUrl('/');
  }

  return authService.fetchFreshUser().pipe(
    map((user) => (user?.is_admin ? true : router.parseUrl('/')))
  );
};
